<template>
  <div>
    <div class="showName">{{getName}}</div>
    <div class="search-form">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="originData.status"
            placeholder="请选择状态"
          >
            <el-option
              label="禁用"
              value="1"
            ></el-option>
            <el-option
              label="启用"
              value="2"
            ></el-option>
            <el-option
              label="全部"
              value="3"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典项名称" prop="dictName">
          <el-input placeholder="请输入字典项名称" v-model.trim="originData.dictName"></el-input>
        </el-form-item>
        <el-form-item label="字典值" prop="dictValue">
          <el-input placeholder="请输入字典值" v-model.trim="originData.dictValue"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click='search()'
        >查询</el-button>
        <el-button
          size="small"
          @click='rest()'
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addInfo()'
          v-if="functionList.indexOf(
          '322545317777739776')!='-1'"
        >新增字典项</yh-button>
      </div>
    </div>
    <div class="user_table">
      <el-table
        :data="tableData"
        style="width: 100%"
        @row-click="showRow"
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          label="字典项ID"
          prop='id'
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.id}}
          </template>
        </el-table-column>
        <el-table-column  width="200" align="center"  prop="dictTypeName" label="字典类别"/>
        <el-table-column  width="150"  align="center" label="字典项名称">
          <template slot-scope="scope">
            <span class='productDecoration' @click='findDictDetail(scope.row.id,functionList)' v-html='scope.row.dictName'></span>
          </template>
        </el-table-column>
        <el-table-column prop="dictValue" label="字典值"/>
        <el-table-column width="150" align="center" prop="dictOrder" label="排序">
          <template slot-scope="scope">
            <div class="keepOrder">
              <input class="keep_input" style="width:87px;" v-number-only v-model="scope.row.editDictOrder"  @input="scope.row.editDictOrder = Number($event.target.value.replace(/\D+/, ''))"/>
              <span v-if="functionList.indexOf('322545417577009152')!='-1'"
                class="span_keep"
                @click="keepOrder(scope.row)"
              >保存</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span>
              <span v-if="parseInt(scope.row.status)==1">禁用</span>
              <span v-if="parseInt(scope.row.status)==2">启用</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="200"  prop="description" align="center" label="描述">
        </el-table-column>
        <el-table-column width="200"  align="center" prop="updateTime" label="修改时间">
          <template slot-scope="scope">
            {{scope.row.updateTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column width="200"  align="center"  prop="updateUserid" label="修改人ID"/>
        <el-table-column width="100"  align="center" fixed="right" label="操作">
          <template slot-scope="scope">
            <span
              class="button--blue"
              @click="modify(scope.row)"
              type="primary"
              v-if="functionList.indexOf(
          '322545417577009152')!='-1'"
            >修改</span>
            <span
              class="button--blue"
              @click=" isDisables(scope.row ,'2')"
              v-if="scope.row.status==='1'&&functionList.indexOf(
          '322545522463969280')!='-1'"
            >启用</span>
            <span
              class="button--red"
              @click=" isDisables(scope.row ,'1')"
              v-if="scope.row.status==='2'&&functionList.indexOf(
          '322545522463969280')!='-1'"
            >禁用</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <yh-dialog title="新增字典项" :visible.sync="newdic">
      <el-form
        :model="insertDict"
        class="hide-error"
      >
        <el-form-item
          label="字典项名称"
          prop="dictName"
          required
        >
          <el-input
            v-model="insertDict.dictName"
            placeholder="请输入字典项名称，不超过20字"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典值"
          prop="dictValue"
          required
        >
          <el-input
            v-model="insertDict.dictValue"
            placeholder="请输入字典值，不超过500字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别"
          prop="dictTypeName"
        >
          <el-input
            v-model="insertDict.dictTypeName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
        >
          <el-input
            type="textarea"
            v-model="insertDict.description"
            maxlength="200"
            show-word-limit
            placeholder="请输入描述，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="dictOrder"
          required
        >
          <el-input
            v-model="insertDict.dictOrder"
            placeholder="请输入整数，数值越小显示越靠前"
            maxlength="9"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="newdic = false">取消</el-button>
        <el-button
          type="primary"
          :loading="addLoading"
          @click="insertDictClick()"
        >提交</el-button>
      </span>
    </yh-dialog>
    <yh-dialog title="修改字典项" :visible.sync="modifyDic">
      <el-form
        :model="updateDict"
        class="hide-error"
      >
        <el-form-item
          label="字典项名称"
          prop="dictName"
          required
        >
          <el-input
            v-model="updateDict.dictName"
            placeholder="请输入字典项名称，不能超过20字"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典值"
          prop="dictValue"
        >
          <el-input
            v-model="updateDict.dictValue"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别"
          prop="dictTypeName"
        >
          <el-input
            v-model="updateDict.dictTypeName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
        >
          <el-input
            type="textarea"
            v-model="updateDict.description"
            placeholder="请输入描述，不超过200字"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="dictOrder"
          required
        >
          <el-input
            v-model="updateDict.dictOrder"
            placeholder="请输入整数，数值越小显示越靠前"
            maxlength="9"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="modifyDic = false">取消</el-button>
        <el-button
          type="primary"
          :loading="uptLoading"
          @click="updateDictClick()"
        >确定</el-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import { getFunctionList, getPagingData } from '@/mixins';

export default {
  mixins: [getFunctionList, getPagingData],
  data() {
    const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
    return {
      emptyText: this.$LS.empty,
      getName: parentData.dictTypeName,
      // 初始数据
      originData: {
        dictName: '',
        dictValue: '',
        status: '3',
      },
      // 查询数据
      searchParam: {
        dictName: '',
        dictValue: '',
        status: '2',
      },
      newdic: false,
      modifyDic: false,
      functionList: [],
      insertDict: {
        // 新增数据
        dictName: '',
        dictValue: '',
        dictTypeCode: parentData.dictTypeCode,
        dictOrder: '',
        note: '',
        status: '',
      },
      updateDict: {
        // 修改数据
        dictName: '',
        dictValue: '',
        dictTypeCode: '',
        dictOrder: '',
        note: '',
        status: '',
      },
      pageNo: 1,
      currentPage: 1,
      pageSize: 10,
      sumCount: 0,
      tableData: [],
      status: '',
      addLoading: false,
      uptLoading: false,
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.dict_info_query();
      },
    },
    'insertDict.dictOrder': function (val) {
      if (val !== '') {
        this.insertDict.dictOrder = Number(val.toString().replace(/\D+/, ''));
      }
    },
    'updateDict.dictOrder': function (val) {
      if (val !== '') {
        this.updateDict.dictOrder = Number(val.toString().replace(/\D+/, ''));
      }
    },
  },
  mounted() {},
  directives: {
    numberOnly: {
      bind(el) {
        el.handler = function () {
          if (el.value.length > 6) {
            el.value = el.value.toString().substring(0, 9);
          }
          el.value = Number(el.value.replace(/\D+/, ''));
        };
        el.addEventListener('input', el.handler);
      },
      unbind(el) {
        el.removeEventListener('input', el.handler);
      },
    },
  },
  methods: {
    // 字典类型详情
    dict_info_query() {
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      if (parentData.id) {
        const parames = {
          pageMessage: {
            pageSize: this.pageSize,
            pageNo: this.currentPage,
          },
          data: {
            ...this.searchParam,
            dictTypeCode: parentData.dictTypeCode,
          },
        };
        return this.$_post(this.$API.dictValueQuery, parames).then((res) => {
          this.emptyText = this.$LS.loading;
          if (res.errorCode === this.$CODE.success) {
            if (parames.data.dictName === '' && parames.data.dictValue === '' && parames.data.status === '') {
              this.emptyText = this.$LS.empty;
            } else {
              this.emptyText = this.$LS.emptySearch;
              this.tableData = res.data.list.map(item => ({
                ...item,
                editDictOrder: item.dictOrder,
              }));
              this.sumCount = res.sumCount;
            }
          } else {
            this.$message.warning(res.errorMsg);
          }
        });
      }
      return false;
    },
    // 查询
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.dict_info_query();
    },
    // 重置
    rest() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 单选
    showRow(row) {
      this.updateDict = JSON.parse(JSON.stringify(row));
    },
    // 新增按钮
    addInfo() {
      this.newdic = true;
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      Object.keys(this.insertDict).forEach((key) => {
        this.insertDict[key] = '';
      });
      this.insertDict.dictTypeName = parentData.dictTypeName;
    },
    // 新增确定
    insertDictClick() {
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      this.addLoading = true;
      this.$_yh_confirm(
        '字典项新增后将无法删除, 确定要新增吗?',
        '新增字典项',
      ).then(() => {
        const createUserid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
        const params = {
          data: {
            dictTypeCode: parentData.dictTypeCode,
            dictName: this.insertDict.dictName,
            dictValue: this.insertDict.dictValue,
            dictOrder: this.insertDict.dictOrder,
            description: this.insertDict.description,
            status: 2, // 默认启用
            createUserid,
          },
        };
        this.addDictonary(params);
      }).catch(() => {
        this.addLoading = false;
      });
    },
    addDictonary(params) {
      return this.$_post(this.$API.dictValueAdd, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.newdic = false;
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
        this.addLoading = false;
      });
    },
    // 修改按钮
    modify(row) {
      this.modifyDic = true;
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      this.updateDict = JSON.parse(JSON.stringify(row));
      this.updateDict.dictTypeName = parentData.dictTypeName;
    },
    // 修改校验
    updateDictClick() {
      const updateUserid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
      const params = {
        data: {
          dictOrder: this.updateDict.dictOrder,
          description: this.updateDict.description,
          status: this.updateDict.status,
          dictName: this.updateDict.dictName,
          dictValue: this.updateDict.dictValue,
          dictTypeCode: this.updateDict.dictTypeCode,
          id: this.updateDict.id,
          updateUserid,
        },
      };
      this.updateDictionary(params);
    },
    // 修改提交
    updateDictionary(params) {
      return this.$_post(this.$API.dictValueEdit, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.currentPage = 1;
          this.dict_info_query();
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 修改后保存展示顺序
    keepOrder(row) {
      const regPos = /^\d+$/;
      if (
        !regPos.test(row.editDictOrder)
        || parseInt(row.editDictOrder, 10).toString().length > 6
      ) {
        this.$message.warning('排序值仅支持0-999999范围内的整数');
        return;
      }
      const updateUserid = JSON.parse(sessionStorage.getItem('sessionData'))
        .userId;
      const params = {
        data: {
          dictOrder: row.editDictOrder,
          id: row.id,
          updateUserid,
        },
      };
      this.$_post(this.$API.dictValueEdit, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.currentPage = 1;
          this.dict_info_query();
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 是否修改禁用启用状态
    isDisables(row, status) {
      let str = '';
      const name = row.dictName;
      if (status === '2') {
        str = '启用';
        this.$confirm(`确定要${str}"${name}"字典项?`, `${str}字典项`, {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.disables(row, status);
          })
          .catch(() => {});
      } else if (status === '1') {
        str = '禁用';
        this.$confirm(
          `禁用后，前端界面对应的下拉列表中将不显示该字典项(但不影响已产生的历史数据)，确定要${str}"${name}"字典项?`,
          `${str}字典项`,
          {
            confirmButtonText: `${str}`,
            cancelButtonText: '取消',
            closeOnClickModal: false,
          },
        )
          .then(() => {
            this.disables(row, status);
          })
          .catch(() => {});
      }
    },
    // 修改禁用启用的状态
    disables(row, status) {
      const updateUserid = JSON.parse(sessionStorage.getItem('sessionData'))
        .userId;
      const params = {
        data: {
          status,
          id: row.id,
          updateUserid,
        },
      };
      this.$_post(this.$API.dictValueEdit, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.currentPage = 1;
          this.dict_info_query();
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
 .keep_input {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  .keep_input:focus {
    border-color: #54a6de;
    outline: 0;
  }
.showName {
  font-size: 24px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.keepOrder .keep_input {
  width: 50px;
  padding: 2px;
  color: #515974;
}
.keepOrder .span_keep {
  margin-left: 10px;
  color: #1e88ff;
  cursor: pointer;
}
.el-row {
  text-align: center;
}
.el-col {
  margin-top: 10px;
}
</style>
